import { MyInterviewWidgetAction } from '@/actions/pages/clients/recruitment/my-interview-widget';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { createHmac } from "crypto";
import Tooltip from "react-simple-tooltip";
import { MY_INTERVIEW_JOBS, useTranslation } from '@/imports-files/common/common';
import Button from "@/components/button";
import ButtonStyle from "@/styles/components/button/_index.module.scss";


export default function MyInterviewWidget(props)
{
  const router = useRouter();
  const { t } = useTranslation();
  const myInterviewWidgetAction= new MyInterviewWidgetAction();
  const expiry =  Math.floor(Date.now() / 1000);
  const objectId = process.env.NEXT_PUBLIC_MY_INTERVIEW_API_KEY;
  const secret_key = process.env.NEXT_PUBLIC_MY_INTERVIEW_SECRET_KEY;

  function createSignature(objectId, secret_key, expiry, securityLevel = "apikey") {
    if (expiry instanceof Date) {
      expiry = expiry.getTime() / 1000;
    }
    const key = `${securityLevel} ${objectId}${expiry ? ' exp=' + expiry : ''} sig=`;
    const hmac = createHmac('sha256', secret_key);
    hmac.update(key.replace(/\s*/gi, ''));
    const signature = hmac.digest('hex');
    return `${key}${signature}`;
  }
  const videoIcon = "/icons/video_icon.png";
  const buttonStyle = {
    width: '100%',
    display: 'flex',
    backgroundColor: '#264B85',
    color: 'white',
    margin: '0 0 15px 0',
    border: '1px solid #264B85',
    borderRadius: '6px',
    textTransform: 'capitalize',
    cursor: 'pointer',
    height: '40px',
    fontWeight: '700',
    fontFamily: 'Whitney',
    fontSize: '14px',
    letterSpacing: '0',
    alignItems: 'center',
    justifyContent: 'center'
  };
  useEffect(()=>{
    if(document)
    {
      const script = document.createElement("script");
      script.src = "https://embed.myinterview.com/myint-widget/1.1.11/index.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      script.onload = () => {
          document.querySelector("myinterview-widget").widgetConfig = {
          buttonText: props.buttonText || t("button:video_introduction"),
          buttonStyle: buttonStyle,
          disabled: props.isDisabled,
          config: {
              auth: `${createSignature(objectId, secret_key)}`,
              minimizable: true,
              hideHeader: true,
              onWidgetClicked: () => console.log('Widget Clicked!'),
              onFinish: (data) => {
                document.getElementById("myinterview-videoId").value = data.video_id
               if (props.setVideoAttached)
                {
                props.setVideoAttached(true);
                }

               if(props.from == 'candidate')
                {
                     myInterviewWidgetAction.setInterviewVideo(props.from, router.query.token)
                }
              },
              onError: (data) => console.log('Error Message:', data.messageType),
              onWidgetClose: () => console.log('Widget minimized by the candidate'),
              introVideo: props.video_link ? props.video_link : "",
              disablePractice: !props.practise_screen || false,
              practiceQuestions: [
                {
                  question: t('agency:video:practice_question'),
                  description: '',
                  attempts: 3,
                  duration: 60,
                  thinkingTime: 0
                }
              ]
          },
          job:{
            title: 'Heartpace '+ props.job_title,
            language: props.language || 'en',
            questions: props.questions
          },
          candidate: {
              username: props.user_details.username,
              email: props.user_details.email,
              reapply: true,
          }
        }
      }
    }
  },[props.isDisabled])
    return (props.job_title == MY_INTERVIEW_JOBS.CANDIDATE_INTRODUCTION ? <Tooltip className={props.isDisabled ? 'SimpleTooltip' : 'hideMyinterviewToastr SimpleTooltip' } customCss={{display: "revert"}} content={t("agency:video:warning")} fixed={false} background= {'#00325A'} radius={20} padding = {8}  placement = "top" fontSize="12px">
      <p className="tooltipwidthmyinterview" ><myinterview-widget></myinterview-widget></p>
      </Tooltip> : <myinterview-widget></myinterview-widget>)
}